var _style, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconToggleSectionArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29 29",
    style: {
      enableBackground: "new 0 0 29 29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3,12.2c0.1,0,0.2-0.1,0.2-0.3c0-0.1,0-0.2-0.1-0.3c-0.2-0.2-0.5-0.2-0.6,0l-5.3,5.2l-5.2-5.2c-0.1-0.1-0.2-0.1-0.3-0.1 s-0.2,0-0.3,0.1c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0,0.2,0.1,0.3l5.9,5.9L20.3,12.2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 29,
    height: 29
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToggleSectionArrow);
export default __webpack_public_path__ + "static/media/icon-toggle-section-arrow.27bbbcf5f04fce3a737cc734f7d68f73.svg";
export { ForwardRef as ReactComponent };